$(function() {

  'use strict';

  var _this,
      _window = $(window);

  /**
   * 確認ボタン
   */
  $(function() {
    var consent = $('#contact').find('#consent'),
        submit  = $('#contact').find('.submit');

    consent.change(function() {
      var _this = $(this);

      if(_this.is(':checked')) {
        submit.parent('div').removeClass('is-disabled');
      } else {
        submit.parent('div').addClass('is-disabled');
      }
    });

    $('.mw_wp_form_input .submit').attr('disabled', 'disabled');


    const inputEdit = document.querySelector('.form__consent-inner');
    console.log(inputEdit)
    if (inputEdit) {
      const input = document.createElement("input");
      input.id = "consent";
      input.name = "consent";
      input.type = "checkbox";
      inputEdit.prepend(input);
      console.log(inputEdit)
    }
  });


  // ラジオボタン＆チェックボックスでテキスト改行（管理画面で入力した<br>を文字列ではなく改行として出力）
  $('.mwform-radio-field-text').each(function () {
    var text = $(this).html();
    $(this).html(text.replace('&lt;br&gt;', '<br>'));
  });

  /**
   * タブ切り替え
   */
  $(function() {
    var TAB = $('.js-form-tab-button');

    var TABS = {
      _1: $('#tab-1'),
      _2: $('#tab-2')
    };

    var TABCONT = $('.mw_wp_form_input .form-contents');
    var TAB_1_HIDE = $('.is-tab-1-hide');
    var TAB_2_HIDE = $('.is-tab-2-hide');

    function tabChange() {
      if(TAB.is(':checked')) {
        TABCONT.show();
      } else {
        TABCONT.hide();
      }

      if(TABS._1.is(':checked')) {
        TAB_2_HIDE.show();
        TAB_1_HIDE.hide();
      } else {
        TAB_1_HIDE.show();
        TAB_2_HIDE.hide();
      }
    }

    tabChange();

    TAB.change(function() {
      tabChange();
    });

    // 選択肢によって確認画面の表示を変更

    if($('.mw_wp_form_confirm .js-form-tab-confirm').length){
      var area = $('.mw_wp_form_confirm .js-form-tab-confirm').html();
      if ( area.indexOf('弊社サービスの&lt;br&gt;ご利用・ご検討') != -1) {
        $('.is-tab1').addClass('is-select');
        TAB_2_HIDE.show();
        TAB_1_HIDE.hide();
      }
      if ( area.indexOf('貴社サービスの&lt;br&gt;ご紹介・セールス') != -1) {
        $('.is-tab2').addClass('is-select');
        TAB_1_HIDE.show();
        TAB_2_HIDE.hide();
      }
    }
  });

  /**
   * フォーム 電話番号
   */
  $(function() {
    var _return_value = '';

    // 入力値の半角数字チェック
    function check_numtype(obj) {
      var txt_obj = $(obj).val();
      var text_length = txt_obj.length;

      if(txt_obj.match(/^[-0-9 ]+$/)) {
      } else {
        if(text_length == 0) {
          $('.js-only-num').val('');
          _return_value = '';
        } else {
          $('.js-only-num').val(_return_value);
        }
      }
    }
  });

  /**
   * 募集要項からのリンク
   */
  (function() {
    var arg  = new Object,
        pair = location.search.substring(1).split('&');

    for(var i=0; pair[i]; i++) {
      var kv = pair[i].split('=');
      arg[kv[0]]=kv[1];
    }

    if(Object.keys(arg).length === 0) {
      // パラメータがない場合
      $('.js-form-tab-button-1').next().trigger('click');
    } else {
      var urlParam = location.search.substring(1);

      if(urlParam) {
        var param = urlParam.split('&');

        var paramArray = [];

        for(i = 0; i < param.length; i++) {
          var paramItem = param[i].split('=');
          paramArray[paramItem[0]] = paramItem[1];
        }

        // パラメータtypeがentryかどうかを判断する
        if(paramArray.type == 'entry') {
          $('#adoption label').trigger('click');
          $('#jobSelect option').prop('selected', false);
          $('#jobSelect .' + arg.jobs).prop('selected', true);
        }
      }
    }
  }());

});
